module.exports = __webpack_public_path__ + "static/img/Permiso(4).593f667.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fotografias/Permiso(4).jpg
// module id = L3cQ
// module chunks = 0